import { useState, useRef, useEffect } from 'react';

const ViewportObservable = props => {
  const {
    // viewport handle from Viewport component
    viewport,

    // track element with key for viewport
    viewportKey,

    // flag to initialize as visible
    initVisible,

    // flag to keep visibility once visible
    keepVisible,

    // child components will be rendered when visible
    children
  } = props;

  const ref = useRef();
  const [visible, setVisible] = useState(!!initVisible);
  const onEnter = () => setVisible(true);
  const onExit = () => {
    if (!keepVisible) {
      setVisible(false);
    }
  }

  useEffect(() => {
    if (ref.current) {
      viewport.observe(viewportKey, ref.current, onEnter, onExit);
    }
  }, [ref.current]);

  let contents = null;
  if (visible) {
    contents = children;
  }

  return <div ref={ref} style={{width: '100%', height: '100%'}}>{contents}</div>;
}

export default ViewportObservable;
